import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";
import uploadData from "../services/uploadData";

const handleFetchVehicles = async ({ keyword = "", state = "" }: any) => {
  const uri = `v1/vehicles?keyword=${keyword}&state=${state}`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchMatched = async ({ keyword = "", match = true }: any) => {
  const uri = `v1/vehicles/matched?keyword=${keyword}&match=${match}`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchVehiclesStats = async () => {
  const uri = `v1/vehicles/stats`;
  const response = fetchData({ uri });
  return response;
};

const handleUpdateVehicleProgrammed = async ({ _id, data }: any) => {
  const uri = `v1/vehicles/${_id}/programmed`;
  const response = patchData({ data, uri });
  return response;
};

const handleCreateVehicle = async ({ data }: any) => {
  const uri = `v1/vehicles`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateVehicle = async ({ _id, data }: any) => {
  const uri = `v1/vehicles/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateProgrammed = async ({ _id, data }: any) => {
  const uri = `v1/vehicles/${_id}/programmed`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateLeft = async ({ _id, data }: any) => {
  const uri = `v1/vehicles/${_id}/left`;
  const response = patchData({ data, uri });
  return response;
};
const handleUpdateUnprogrammed = async ({ _id, data }: any) => {
  const uri = `v1/vehicles/${_id}/unprogrammed`;
  const response = patchData({ data, uri });
  return response;
};

const handleDeleteVehicle = async ({ data, _id }: any) => {
  const uri = `v1/vehicles/${_id}`;
  const response = deleteData({ data, uri });
  return response;
};

const handleUploadVehicles = async ({ data }: any) => {
  const uri = `v1/vehicles/upload`;
  const response = uploadData({ data, uri });
  return response;
};

export {
  handleFetchVehicles,
  handleFetchMatched,
  handleFetchVehiclesStats,
  handleUpdateVehicleProgrammed,
  handleCreateVehicle,
  handleUpdateVehicle,
  handleDeleteVehicle,
  handleUpdateProgrammed,
  handleUploadVehicles,
  handleUpdateUnprogrammed,
  handleUpdateLeft,
};
